import * as ambassadorWixBadgesV4Badge from './badges-v4-badge-badges-v-2.http.js';
import * as ambassadorWixBadgesV4BadgeTypes from './badges-v4-badge-badges-v-2.types.js';
import * as ambassadorWixBadgesV4BadgeUniversalTypes from './badges-v4-badge-badges-v-2.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createBadge(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBadgesV4BadgeUniversalTypes.CreateBadgeRequest,
  ambassadorWixBadgesV4BadgeTypes.CreateBadgeRequest,
  ambassadorWixBadgesV4BadgeUniversalTypes.CreateBadgeResponse,
  ambassadorWixBadgesV4BadgeTypes.CreateBadgeResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBadgesV4Badge.createBadge(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/badges',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getBadge(): __PublicMethodMetaInfo<
  'GET',
  { badgeId: string },
  ambassadorWixBadgesV4BadgeUniversalTypes.GetBadgeRequest,
  ambassadorWixBadgesV4BadgeTypes.GetBadgeRequest,
  ambassadorWixBadgesV4BadgeUniversalTypes.GetBadgeResponse,
  ambassadorWixBadgesV4BadgeTypes.GetBadgeResponse
> {
  const payload = { badgeId: ':badgeId' } as any;

  const getRequestOptions = ambassadorWixBadgesV4Badge.getBadge(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/badges/{badgeId}',
    pathParams: { badgeId: 'badgeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBadges(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBadgesV4BadgeUniversalTypes.QueryBadgesRequest,
  ambassadorWixBadgesV4BadgeTypes.QueryBadgesRequest,
  ambassadorWixBadgesV4BadgeUniversalTypes.QueryBadgesResponse,
  ambassadorWixBadgesV4BadgeTypes.QueryBadgesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBadgesV4Badge.queryBadges(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/badges/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateBadge(): __PublicMethodMetaInfo<
  'PATCH',
  { badgeId: string },
  ambassadorWixBadgesV4BadgeUniversalTypes.UpdateBadgeRequest,
  ambassadorWixBadgesV4BadgeTypes.UpdateBadgeRequest,
  ambassadorWixBadgesV4BadgeUniversalTypes.UpdateBadgeResponse,
  ambassadorWixBadgesV4BadgeTypes.UpdateBadgeResponse
> {
  const payload = { badge: { id: ':badgeId' } } as any;

  const getRequestOptions = ambassadorWixBadgesV4Badge.updateBadge(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v4/badges/{badge.id}',
    pathParams: { badgeId: 'badgeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteBadge(): __PublicMethodMetaInfo<
  'DELETE',
  { badgeId: string },
  ambassadorWixBadgesV4BadgeUniversalTypes.DeleteBadgeRequest,
  ambassadorWixBadgesV4BadgeTypes.DeleteBadgeRequest,
  ambassadorWixBadgesV4BadgeUniversalTypes.DeleteBadgeResponse,
  ambassadorWixBadgesV4BadgeTypes.DeleteBadgeResponse
> {
  const payload = { badgeId: ':badgeId' } as any;

  const getRequestOptions = ambassadorWixBadgesV4Badge.deleteBadge(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v4/badges/{badgeId}',
    pathParams: { badgeId: 'badgeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateBadgesDisplayOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBadgesV4BadgeUniversalTypes.UpdateBadgesDisplayOrderRequest,
  ambassadorWixBadgesV4BadgeTypes.UpdateBadgesDisplayOrderRequest,
  ambassadorWixBadgesV4BadgeUniversalTypes.UpdateBadgesDisplayOrderResponse,
  ambassadorWixBadgesV4BadgeTypes.UpdateBadgesDisplayOrderResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBadgesV4Badge.updateBadgesDisplayOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/badges/order',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function moveBadge(): __PublicMethodMetaInfo<
  'POST',
  { badgeId: string },
  ambassadorWixBadgesV4BadgeUniversalTypes.MoveBadgeRequest,
  ambassadorWixBadgesV4BadgeTypes.MoveBadgeRequest,
  ambassadorWixBadgesV4BadgeUniversalTypes.MoveBadgeResponse,
  ambassadorWixBadgesV4BadgeTypes.MoveBadgeResponse
> {
  const payload = { badgeId: ':badgeId' } as any;

  const getRequestOptions = ambassadorWixBadgesV4Badge.moveBadge(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/badges/{badgeId}/move',
    pathParams: { badgeId: 'badgeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Badge as BadgeOriginal,
  Image as ImageOriginal,
  MigrationBadgeUpdated as MigrationBadgeUpdatedOriginal,
  MigrationBadge as MigrationBadgeOriginal,
  MigrationBadgeCreated as MigrationBadgeCreatedOriginal,
  CreateBadgeRequest as CreateBadgeRequestOriginal,
  CreateBadgeResponse as CreateBadgeResponseOriginal,
  GetBadgeRequest as GetBadgeRequestOriginal,
  GetBadgeResponse as GetBadgeResponseOriginal,
  QueryBadgesRequest as QueryBadgesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryBadgesResponse as QueryBadgesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryBadgesLegacyRequest as QueryBadgesLegacyRequestOriginal,
  Paging as PagingOriginal,
  QueryBadgesLegacyResponse as QueryBadgesLegacyResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  UpdateBadgeRequest as UpdateBadgeRequestOriginal,
  UpdateBadgeResponse as UpdateBadgeResponseOriginal,
  DeleteBadgeRequest as DeleteBadgeRequestOriginal,
  DeleteBadgeResponse as DeleteBadgeResponseOriginal,
  UpdateBadgesDisplayOrderRequest as UpdateBadgesDisplayOrderRequestOriginal,
  UpdateBadgesDisplayOrderResponse as UpdateBadgesDisplayOrderResponseOriginal,
  MoveBadgeRequest as MoveBadgeRequestOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  MoveBadgeResponse as MoveBadgeResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateBadgeValidationErrors as UpdateBadgeValidationErrorsOriginal,
} from './badges-v4-badge-badges-v-2.types.js';
